/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import debounce from 'lodash.debounce';

import {Link, useLocation} from "react-router-dom";

import * as Actions from "actions";
import {
  isShopSiteAndSubdomain,
  isMarketPlace,
  checkProductInCart,
  getLogo,
  isFeatureSupported,
  getURI, getPrice
} from "helpers/utils";

import {
  TextField, InputAdornment, IconButton, Container, Typography, Chip, Box, Grid,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ShopProductItem from "components/elements/user/products/ShopProductItem";
import ShopProductDetail from "components/elements/user/products/ShopProductDetail";
import SearchIcon from "@mui/icons-material/Search";
import SlideshowIcon from '@mui/icons-material/Slideshow';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { H6 } from "components/CustomTypography";
import {SearchOutlinedIcon} from "../UserCombinedSearch";
import StoriesPlayer from "components/StoriesPlayer/StoriesPlayer";
import MockProductBoxList from "components/elements/main/MockProductBoxList";
import ShopCategorySelector from "components/elements/user/products/ShopCategorySelector";
import CustomSectionCreator from "components/CustomSectionCreator";
import CustomFlexBox from "../../../CustomFlexBox";
import {Button} from "../../../Atoms";
import UserProductStatusSelector from "../../../elements/user/products/UserProductStatusSelector";
import ButtonComponent from "../../../Button";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ShopProductSearch = (props) => {
  const [state, setState] = useState({
    limit: 20,
    hasMoreItems: true,
    breakPoint: "lg",
    bShowSearchModal: false,
    searchvalue: "Search products",
    isShop: true,
  });

  const [productState, setProductState] = useState("");
  const [productModeState, setProductModeState] = useState("PREVIEW");
  const [categoryState, setCategoryState] = useState({ selectedCategory: (props.categoryInput ? props.categoryInput : null) });
  const [optionValues, setOptionValues] = useState([]);

  const [sortState, setSortState] = useState("popular");
  const [offsetState, setOffsetState] = useState(0);

  const [loadStoryState, setLoadStoryState] = useState(false);

  const {
    isLoading,  currency, addProductToCart, addProductToWishlist, addToCompare,
    userResetSearchProducts, userResetsearchKeywords,
    usersearchProducts, usersearchKeywords,
    usergetProductCategories,
    userGetProductInfo,
    bootupInfo,
    products, productdetail, searchkeywords, match, history, symbol = "$",
    categoryList,
    cartItems, cartAddingPid, isCartLoading,
    shopId, isShop, limit,
  } = props;

  const { keywords } = searchkeywords;
  const {
    resetvalue,
  } = state;

  const { query } = match.params;
  const { sort } = match.params;

  const urlparams = useLocation();

  useEffect(() => {

    // Get a specific query parameter
    const checkStory = new URLSearchParams(urlparams.search).get('loadstory');

    if (checkStory) {
      setLoadStoryState(true);
    }

    if (sort) {
      setSortState(sort);
    }

    if (query) {
      userResetSearchProducts();
      usersearchProducts(query, shopId, isShop, isShopSiteAndSubdomain(), "", sort, 0);
    } else {
      usergetProductCategories(shopId, isShop, isShopSiteAndSubdomain());
      // load with default category
      usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 0);
    }
  }, []);

  const runSearch = (keyword) => {
    userResetsearchKeywords();
    setState({ searchquery: keyword });
    setState({ resetvalue: "" });

    if (isShopSiteAndSubdomain()) {
      history.push(`/products/search/${keyword}`);
    } else {
      history.push(`/shop/${shopId}/products/search/${keyword}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      runSearch(e.target.value);
    }
  };

  const setKeyword = (option, type) => {
    if (type === "selectOption") {
      runSearch(option.target.innerText);
    }
  };

  const runKeywordSearch = (value) => {
    setState({ resetvalue: value });
    if ((value.length > 1)) {
      usersearchKeywords(value, isShopSiteAndSubdomain() ? bootupInfo.appState.subdomain_shopId : shopId, isShop, isShopSiteAndSubdomain(), limit);
    }
  };

  const debouncedChangeHandler = useCallback(
      debounce(runKeywordSearch, 300)
      , []);

  const selectKeywordSearch = (value) => {
    if (isShopSiteAndSubdomain()) {
      history.push(`/products/search/${value}`);
    } else {
      history.push(`/shop/${shopId}/products/search/${value}`);
    }
  };

  const handleDelete = () => {
    if (isShopSiteAndSubdomain()) {
      history.push("/products");
  } else {
      history.push(`/shop/${shopId}/products`);
    }
  };

  const handleProductView = (mode, product, reset) => () => {
    setProductModeState(mode);
    if (reset) {
      setProductState({
        selectedProduct: {
          _id: "", status: "", order_type: ""
        },
      });
    } else {
      userGetProductInfo(product._id);
      setProductState({
        selectedOrder: {
          _id: product._id, status: product.status
        },
      });
    }
  };

  const resetCategory = () => {
    setOffsetState(0);
    setCategoryState({ selectedCategory: null });
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 0);
  };

  const setCategory = (category) => {
    setOffsetState(0);
    setCategoryState({ selectedCategory: category.id });
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), category.id, sort, 0);
  };

  const openStoriesView = () => {
    setProductModeState("STORIES");
  };

  useEffect(() => {
    setOptionValues(keywords);
  }, [keywords]);


  const setProductStatus = (sort) => {
    setOffsetState(0);
    setSortState(sort);
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 0);
  };

  const handleRestAll = () => {
    setOffsetState(0);
    setSortState("");
    setCategoryState("");
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, 0);
  };

  const handlePrevOffset = () => {
    const offset = offsetState > 1 ? offsetState - 1 : 0;
    setOffsetState(offset);
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, offset);
  };

  const handleNextOffset = () => {
    const offset = offsetState + 1;
    setOffsetState(offset);
    usersearchProducts("", shopId, isShop, isShopSiteAndSubdomain(), "", sort, offset);
  };

  const MobileViewOnClick = () => {
    if (window.innerWidth <= 500 && (match.path !== "/products/search" || match.path !== "/shop/:shopId/products/search")) {
      history.push(isShopSiteAndSubdomain() ?  "/products/search" : `/shop/${shopId}/products/search`);
    }
  };

  let isModalSearch = false;

  const renderNoResults = () => (
      <Container>
        <Box>
          <Typography className="m-2" align="center">
            <H6>
              No product found
            </H6>
          </Typography>
        </Box>
      </Container>
  );

  var type = {
    'new': 'Latest Products',
    'popular': 'Popular Products',
    'default': 'Popular Products'
  };

  const renderResults = () => (
      <div>
        {isFeatureSupported("shopreels") &&
            <CustomFlexBox sx={{
              display: 'flex',
              flexDirection: 'row',
              position: 'fixed',
              width: '100%',
              bottom: 70,
              justifyContent: 'center',
              zIndex: 'modal'
            }}>
              <Button
                  sx={{marginRight: '2px'}}
                  size="large"
                  color="primary"
                  variant="contained"
                  onClick={openStoriesView}
              >
                <SlideshowIcon /> Open {process.env.REACT_APP_REELS_TAG}
              </Button>
            </CustomFlexBox>
        }
      <Grid item container md={9} xs={12} spacing={0}>
        {products.map((product, index) => (
            <Grid item xs={6} sm={4} key={index}>
              <ShopProductItem
                  product={product}
                  symbol={currency}
                  inCart={checkProductInCart(cartItems, product.id)}
                  isCartLoading={isCartLoading}
                  cartAddingPid={cartAddingPid}
                  shopId={shopId}
                  onAddToWishlistClicked={() => addProductToWishlist(product._id)}
                  onAddToCartClicked={() => addProductToCart(product._id, isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId, !isMarketPlace())}
                  viewProduct={handleProductView("VIEW", product._id, false)}
                  key={`${index + 1}`}
              />
            </Grid>
        ))}
      </Grid>
      </div>
  );

  const storiesData = products.map((item) => {
    const {id, images, video, name, logo, area} = item;

    let stories = [];

    if (video && video.length > 0) {
      stories.push({
        video: video[0].cdn.secure_url,
      });
    } else {
      images && images.map((product) => (
          stories.push({
            image: product.cdn.secure_url,
          })
      ));
    }


    return (
        {
          user: {
            name: "Buy: " + getPrice(item, currency),
            userLink: '/#' + getURI(process.env.REACT_APP_TYPE, "shop_product", shopId, id, ""),
            area: area,
          },
          stories: stories,
        }
    );
  });

  const renderResultsAsStories = () => (
      <div>
        <StoriesPlayer
            storiesData={storiesData}
            onCancel={() => setProductModeState("PREVIEW")}
        />
      </div>
  );

  const renderSearchHelp = () => (
      <Container>
        <Box>
          {
            window.innerWidth <= 500
            && (match.path === "/products/search" || match.path === "/shop/:shopId/products/search")
            && optionValues.map((element) => (
                <Container>
                  <Typography onClick={() => history.push(`search/${element.label}`)}>
                    <IconButton disabled size="large">
                      <SearchIcon />
                    </IconButton>
                    {element.label}
                  </Typography>
                </Container>
            ))
          }
        </Box>
      </Container>
  );

  const renderSearchModule = () => (
    <>

      <Container onClick={MobileViewOnClick}>
          <Box mb={2}>
        {
            window.innerWidth <= 500
            && (match.path === "/products/search" || match.path === "/shop/:shopId/products/search" ) ? isModalSearch = true : isModalSearch = false
          }
        <Autocomplete
          id="autocomplete"
          onClose={setKeyword}
          disableClearable
          freeSolo
          inputValue={resetvalue}
          onOpen={() => setState({ selected: false })}
          value={resetvalue}
          onKeyPress={handleKeyPress}
          onSelect={(input) => debouncedChangeHandler(input.target.value)}
          options={window.innerWidth <= 500 ? [] : optionValues.map((element) => element.label)}
          renderInput={(params) => (
            <TextField
                {...params}
              InputProps={{
                sx: {
                  height: 44,
                  paddingRight: 0,
                  borderRadius: 0,
                  color: "grey.900",
                  overflow: "hidden",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "primary.main",
                  },
                },
                startAdornment: <SearchOutlinedIcon fontSize="small" />,
              }}
              autoFocus={isModalSearch}
              placeholder={`Search ${process.env.REACT_APP_PRODUCT_TITLE}`}
            />
          )}
        />
        </Box>
      </Container>

      {
        renderSearchHelp()
          }

      <Container>
        {query && (
        <Chip
          label={query}
          onDelete={handleDelete}
        />
        )}
      </Container>

      { /* match.path !== "/product"
      && */ match.path !== "/"
      && (
          match.path === "/products" ||
          match.path === "/products/search/:query" ||
          match.path === "/products/sort/:sort" ||
          match.path === "/shop/:shopId/products" ||
          match.path === "/shop/:shopId/products/search/:query" ||
          match.path === "/shop/:shopId/products/sort/:sort"
      ) && (
      <>
        { !query &&
            <ShopCategorySelector
                title="All Product Categories"
                categoryList={categoryList}
                handlePage={handlePage}
                resetCategory={resetCategory}
                onCategorySelect={setCategory}
                selectedCategory={selectedCategory}
            />
        }
        {/* !query && (<CustomSectionCreator title={type[sort] || type['default']}  />) */}
        {query && (<CustomSectionCreator title={"Searching: '" + query + "'"} />)}

        <CustomFlexBox alignItems="center" mb={2} sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}>
          <Box width="50%">
            <UserProductStatusSelector
                onStatusSelect={setProductStatus}
                productstatus={sortState}
            />
          </Box>
          <Box width="20%">
            <ButtonComponent
                type="primary"
                variant="text"
                name="Reset"
                size="medium"
                onClick={handleRestAll}>
            </ButtonComponent>
          </Box>
          <Box width="30%">
            {!(isLoading) && products.length > 0 && <CustomFlexBox sx={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
            }}>
              <Box width="50%" align="right">
                {offsetState > 0 && <IconButton onClick={handlePrevOffset}>
                  <ArrowBackIosIcon fontSize="medium" color="primary"/>
                </IconButton>
                }
              </Box>
              <Box width="50%" align="right">
                <IconButton onClick={handleNextOffset}>
                  <ArrowForwardIosIcon fontSize="medium" color="primary"/>
                </IconButton>

              </Box>
            </CustomFlexBox>
            }

          </Box>
        </CustomFlexBox>

        {isLoading ? <MockProductBoxList />
            : products.length > 0
              ? renderResults()
              : renderNoResults()}
        {!isLoading && products.length > 0 && loadStoryState === true ? (openStoriesView(), setLoadStoryState(false)) : ""}
      </>
      )}
    </>
  );

  const renderProductView = (productMode) => {
    switch (productMode) {

      case "STORIES":
        return renderResultsAsStories();

      case "VIEW":
      default:
        return (
            <ShopProductDetail
                setState={(value, field) => setProductState({
                  ...state,
                  selectedProduct: {
                    ...selectedProduct,
                    [field]: value,
                  },
                })}
                symbol={symbol}
                productdetail={productdetail}
                selectedProduct={selectedProduct}
                onAddToWishlistClicked={addProductToWishlist}
                onAddToCartClicked={() => addProductToCart(productdetail.id, isMarketPlace() ? shopId : bootupInfo.appState.subdomain_shopId, !isMarketPlace())}
                onCancel={() => setProductModeState("PREVIEW")}
            />
        );
    }
  };

  const handlePage = (page) => (e) => {
    history.push(page);
  };

  const { selectedProduct = {} } = productState;
  const { records } = products;
  const { categories } = categoryList;
  const { selectedCategory = {} } = categoryState;

  return (
      <Container>
        {productModeState === "PREVIEW" ? (
            renderSearchModule()
        ) : (
            renderProductView(productModeState)
        )}
      </Container>
  );

};

ShopProductSearch.defaultProps = {
  currency: "",
};

ShopProductSearch.propTypes = {
  currency: PropTypes.string,
  addProductToCart: PropTypes.func.isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  categoryList: PropTypes.arrayOf(PropTypes.object),
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  searchkeywords: PropTypes.objectOf(PropTypes.any).isRequired,
  addProductToWishlist: PropTypes.func.isRequired,
  addToCompare: PropTypes.func.isRequired,
  usersearchProducts: PropTypes.func.isRequired,
  usersearchKeywords: PropTypes.func.isRequired,
  userResetsearchKeywords: PropTypes.func.isRequired,
  userResetSearchProducts: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const ShopProductSearchComponent = connect(
  ({ userproducts, cartList, bootupInfo }) => ({
    bootupInfo,
    currency: bootupInfo.symbol,
    reqStatus: userproducts.reqStatus,
    isLoading: userproducts.isLoading,
    serviceError: userproducts.serviceError,
    products: userproducts.searchproducts,
    productdetail: userproducts.productdetail,
    cartItems: cartList.cart,
    isCartLoading: cartList.isLoading,
    cartAddingPid: cartList.cartAddingPid,
    searchkeywords: userproducts.searchkeywords,
    categoryList: userproducts.categoryList,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopProductSearch);

export { ShopProductSearchComponent as default };
